import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Ledger  {
    _originalTypeClassName = "zERP.BO.Ledger";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Ledger.translate = translateService;
}
this.Journals = [];
this.AccountCategories = [];
this.SubLedgers = [];
this.Entity = new Domain.AccountingBusinessEntity();
this.ChartOfAccounts = [];
this.LedgerID = null;
this.Name = null;
this.isDoubleEntry = false;
this.isDefault = false;
this.CodeLevels = null;
this.SourceCode = null;
this.DateLastUpdated = null;
this.Prefix = null;
this.NextSerialNumber = 1;
this.TransferLedger = false;
this.TransferChartOfAccounts = false;
this.TransferAccRules = false;
this.TransferGJRules = false;
this.NumberOfChartAccounts = null;
this.NumberOfAccRules = null;
this.NumberOfGJRules = null;
this.Type = null;
this.FinalNextSerialNumber = null;
this._key = this.LedgerID = 0; 
}

static translate: TranslateService;
_key: any;
private _LedgerID:any;
get LedgerID(): any {
    return this._LedgerID;
  }
set LedgerID(value: any) {
    this._LedgerID = value;
    this._key = value;
  }
Name:any;
isDoubleEntry:any;
isDefault:any;
CodeLevels:any;
SourceCode:any;
DateLastUpdated:any;
Prefix:any;
NextSerialNumber:any;
TransferLedger:any;
TransferChartOfAccounts:any;
TransferAccRules:any;
TransferGJRules:any;
NumberOfChartAccounts:any;
NumberOfAccRules:any;
NumberOfGJRules:any;
Type:any;
FinalNextSerialNumber:any;
Journals:any;
FiscalPeriod:any;
NEWLedger:any;
AccountCodeRule:any;
AccountCategories:any;
SubLedgers:any;
ParentLedger:any;
Entity:any;
ParentAccount:any;
ChartOfAccounts:any;
static setJournals = ($this, items) => {
                if (items == null) items = [];
                if ($this.Journals == null) $this.Journals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Journals.length > 0) {
                    Domain.Ledger.removeJournals($this, $this.Journals[0]);
                }

                Domain.Ledger.addManyJournals($this, copyItems);
            }
static addManyJournals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Ledger.addJournals($this, items[i]);
                }
            }
static addJournals = ($this, item) => {
                if ($this.Journals == null) $this.Journals = [];
                if (item == null || $this.Journals.indexOf(item) > -1) return;
                $this.Journals.push(item);
if (item.Ledger != $this) {
Domain.AccountingJournal.setLedger(item, $this);
}
}
static addRangeJournals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Ledger.addJournals($this, item));
            }
static removeJournals = ($this, item) => {
                if ($this == null || $this.Journals == null || $this.Journals.indexOf(item) === -1) return;
                var _index = $this.Journals.indexOf(item);
                $this.Journals.splice(_index, 1);
item.Ledger = null;
}
static clearJournals = ($this) => { $this.Journals = null; }
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
if (oldValue != null) {
Domain.FiscalPeriod.removeLedgers(oldValue, $this);
}
Domain.FiscalPeriod.addLedgers(value, $this);
}
}
static setNEWLedger = ($this, value) => {
var oldValue = $this.NEWLedger;
$this.NEWLedger = value;
if (value != null) {
}
}
static setAccountCodeRule = ($this, value) => {
var oldValue = $this.AccountCodeRule;
$this.AccountCodeRule = value;
if (value != null) {
}
}
static setAccountCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.AccountCategories == null) $this.AccountCategories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AccountCategories.length > 0) {
                    Domain.Ledger.removeAccountCategories($this, $this.AccountCategories[0]);
                }

                Domain.Ledger.addManyAccountCategories($this, copyItems);
            }
static addManyAccountCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Ledger.addAccountCategories($this, items[i]);
                }
            }
static addAccountCategories = ($this, item) => {
                if ($this.AccountCategories == null) $this.AccountCategories = [];
                if (item == null || $this.AccountCategories.indexOf(item) > -1) return;
                $this.AccountCategories.push(item);
if (item.Ledger != $this) {
Domain.AccountCategory.setLedger(item, $this);
}
}
static addRangeAccountCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Ledger.addAccountCategories($this, item));
            }
static removeAccountCategories = ($this, item) => {
                if ($this == null || $this.AccountCategories == null || $this.AccountCategories.indexOf(item) === -1) return;
                var _index = $this.AccountCategories.indexOf(item);
                $this.AccountCategories.splice(_index, 1);
item.Ledger = null;
}
static clearAccountCategories = ($this) => { $this.AccountCategories = null; }
static setSubLedgers = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubLedgers == null) $this.SubLedgers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubLedgers.length > 0) {
                    Domain.Ledger.removeSubLedgers($this, $this.SubLedgers[0]);
                }

                Domain.Ledger.addManySubLedgers($this, copyItems);
            }
static addManySubLedgers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Ledger.addSubLedgers($this, items[i]);
                }
            }
static addSubLedgers = ($this, item) => {
                if ($this.SubLedgers == null) $this.SubLedgers = [];
                if (item == null || $this.SubLedgers.indexOf(item) > -1) return;
                $this.SubLedgers.push(item);
if (item.ParentLedger != $this) {
Domain.Ledger.setParentLedger(item, $this);
}
}
static addRangeSubLedgers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Ledger.addSubLedgers($this, item));
            }
static removeSubLedgers = ($this, item) => {
                if ($this == null || $this.SubLedgers == null || $this.SubLedgers.indexOf(item) === -1) return;
                var _index = $this.SubLedgers.indexOf(item);
                $this.SubLedgers.splice(_index, 1);
item.ParentLedger = null;
}
static clearSubLedgers = ($this) => { $this.SubLedgers = null; }
static setParentLedger = ($this, value) => {
var oldValue = $this.ParentLedger;
$this.ParentLedger = value;
if (value != null) {
if (oldValue != null) {
Domain.Ledger.removeSubLedgers(oldValue, $this);
}
Domain.Ledger.addSubLedgers(value, $this);
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setParentAccount = ($this, value) => {
var oldValue = $this.ParentAccount;
$this.ParentAccount = value;
if (value != null) {
}
}
static setChartOfAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.ChartOfAccounts == null) $this.ChartOfAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ChartOfAccounts.length > 0) {
                    Domain.Ledger.removeChartOfAccounts($this, $this.ChartOfAccounts[0]);
                }

                Domain.Ledger.addManyChartOfAccounts($this, copyItems);
            }
static addManyChartOfAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Ledger.addChartOfAccounts($this, items[i]);
                }
            }
static addChartOfAccounts = ($this, item) => {
                if ($this.ChartOfAccounts == null) $this.ChartOfAccounts = [];
                if (item == null || $this.ChartOfAccounts.indexOf(item) > -1) return;
                $this.ChartOfAccounts.push(item);
if (item.Ledger != $this) {
Domain.Account.setLedger(item, $this);
}
}
static addRangeChartOfAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Ledger.addChartOfAccounts($this, item));
            }
static removeChartOfAccounts = ($this, item) => {
                if ($this == null || $this.ChartOfAccounts == null || $this.ChartOfAccounts.indexOf(item) === -1) return;
                var _index = $this.ChartOfAccounts.indexOf(item);
                $this.ChartOfAccounts.splice(_index, 1);
item.Ledger = null;
}
static clearChartOfAccounts = ($this) => { $this.ChartOfAccounts = null; }

static CheckParentAccount($this: any, parentCode: any,seperator: any): any{if (Joove.Common.stringEndsWith(parentCode, seperator)) {parentCode = parentCode?.substr(0, Joove.Common.safeNumber(parentCode?.length) - Joove.Common.safeNumber(1));}
return parentCode;
}
static ParseAccountSign($this: any, cellValue: any,signMappings: any): any{if (signMappings.has(cellValue)) {return signMappings.get(cellValue);}
return Domain.AccountSign.NoTransactions;
}
static TransferSubLedgerInfo($this: any, newLedgers: any): any{if ($this?.Type == Domain.LedgerType.SubLedger) {Domain.Ledger.setParentLedger($this.NEWLedger, newLedgers?.linq?.where((l) => l?.Name == $this?.Name)?.firstOrDefault(null));Domain.Ledger.setParentAccount($this.NEWLedger, $this?.NEWLedger?.ChartOfAccounts?.linq?.where((a) => a?.FullCode == $this?.ParentAccount?.FullCode)?.firstOrDefault(null));}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.LedgerID == null || $this.LedgerID == 0;
            }


}